import { DotChip } from "@/components/shared/DotChip";
import { useFoundingOffer } from "@/hooks/useFoundingOffer";
import { foundingOfferSentence, remainingSentence } from "@/lib/pricing/foundingOffer";
import { cn } from "@/lib/utils";

/**
 * The founding-customer offer (code ZAKLADATEL), shown only while Stripe says
 * places are left (`founding-offer` function). Renders nothing before that
 * answer, on any error, and once the code is used up, so there is no deploy to
 * take it down. Used by the landing pricing section and Settings → Předplatné.
 */
export function FoundingOfferNote({
  language,
  className,
}: {
  language: "cs" | "en";
  className?: string;
}) {
  const offer = useFoundingOffer();
  if (!offer?.available || offer.remaining === null) return null;
  const how =
    language === "en"
      ? "Enter the code in the payment form; it applies to the monthly plans."
      : "Kód zadáte v platebním formuláři, platí pro měsíční tarify.";
  return (
    <div
      role="note"
      className={cn(
        "flex flex-wrap items-center gap-x-3 gap-y-1 rounded-lg border border-[hsl(var(--action)/0.4)] bg-primary/10 px-4 py-2.5 dark:border-primary/40",
        className
      )}
    >
      <DotChip color="green" className="whitespace-normal text-[13px] text-foreground">
        {foundingOfferSentence(language)}
      </DotChip>
      <span className="text-[13px] tabular-nums text-muted-foreground">
        {remainingSentence(language, offer.remaining)} {how}
      </span>
    </div>
  );
}
